export const styles = {
  // textTransform:"uppercase",
  borderRadius: 0,
  boxShadow: "none",
  color: "#545454!important",
  fontWeight: "bold",
};
